export default __webpack_public_path__ + "static/media/042-24-hours.081f25d0.png";